import { omitBy, isNil, isEmpty, map, find } from "lodash";
import moment from "moment";

// for filtering purposes, delivery dates must be start of day
const formatStartDate = (date) => {
  if (!date) return null;

  const isValid = moment(date);

  if (!isValid) return null;
  return moment(date).startOf("day");
};

const model = (data) => {
  return omitBy(
    {
      _id: data._id,
      orderCode: data.orderCode,
      orderType: data.orderType,
      senderID: data.senderID._id,
      senderLocationID: data.senderLocationID,
      senderInfo: data.senderInfo,
      senderType: data.senderType,
      receiverInfo: data.receiverInfo,
      deliveryType: data.deliveryType,
      serviceType: data.serviceType,
      specialCare: data.specialCare,
      specialCondition: data.specialCondition,
      trackingNumber: data.trackingNumber,
      weight: data.weight,
      dimension: data.dimension,
      remarks: data.remarks ? data.remarks : null,
      notes: data.notes ? data.notes : null,
      currency: data.currency,
      hasInsurance: data.hasInsurance,
      parcels: data.parcels,
      baseCharges: data.baseCharges,
      additionalCharges: data.additionalCharges,
      totalValueOfGoods: data.totalValueOfGoods,
      totalCharges: data.totalCharges,
      midMileInfo: data.midMileInfo,
      volume: data.volume, //in cm^3
      looseOrders: data.looseOrders ? data.looseOrders : null,
      orderStatusInfo: data.orderStatusInfo,
      deliveryDate: formatStartDate(data.deliveryDate),
    },
    isNil,
  );
};

export default model;
